import {
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Fade,
  Grid,
  makeStyles,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setBooleanValue } from "../../../../reduxadmin/Reducers/dataHasBeenChanged.js";
import React, { useEffect, useState } from "react";
import OrderQueueCard from "../OrderQueueCard/OrderQueueCard.tsx";
import axios from "axios";
import jwtDecode from "jwt-decode";
import OrderItemModal from "./components/OrderItemModal.tsx";
import AutoCompleteMultiSelect from "../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";
import closeIcon from "./../../../../assets/icons/close.png";
import editIcon from "./../../../../assets/icons/editIcon.png";
import { ToastContainer, toast } from "react-toastify";
import chatImg from "./../../../../assets/icons/chat.png";

import clsx from "clsx";
import OrderTableDialog from "../OrderTableDialog/OrderTableDialog.tsx";
import moment from "moment";

import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal.js";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const styleForOrderCancelationModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const OrderDetailsCardContent = ({
  order,
  reloadData,
  restaurantId,
  kitchenselected,
  type,
  readyFoodDetail,
}) => {
  const [showAll, setShowAll] = useState(true);
  const [nextStatus, setNextStatus] = useState("");
  const [prevStatus, setPrevStatus] = useState("");
  const [nextStatusId, setNextStatusId] = useState(0);
  const [prevStatusId, setPrevStatusId] = useState(0);
  const [openTableEdit, setOpenTableEdit] = useState(false);
  const [selectedSubOrder, setSelectedSubOrder] = useState({});
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const [IsWaitersView, setIsWaitersView] = useState(false);

  const [openOrderCancelationModal, setOpenOrderCancelationModal] =
    React.useState(false);
  const handleOpenOrderCancelationModal = () =>
    setOpenOrderCancelationModal(true);
  const handleCloseOrderCancelationModal = () =>
    setOpenOrderCancelationModal(false);

  const [cencalationReasons, setCencalationReasons] = useState(false);
  const [selectCencalationReason, setSelectCencalationReason] = useState(false);
  const [remarks, setRemarks] = useState("N/A");

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };
  const formatTime = (dateTimeString) => {
    if (dateTimeString) {
      const normalizedDateTimeString = dateTimeString.replace(/\.\d+/, "");

      const dateObject = new Date(normalizedDateTimeString);

      if (isNaN(dateObject)) {
        return "Invalid Date";
      }

      const timeOnly = dateObject.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      return timeOnly;
    } else {
      return "N/A";
    }
  };
  const handleOrderStatusChange = async (nextStatusIdFromClickEvent) => {
    dispatch(setBooleanValue(true));
    try {
      var kitchenIds = order?.kitchenViews.map((x) => x.kitchenId);
      let foundWaiterKitchen = kitchenselected?.find(
        (data) => String(data.title) === String("Waiter View")
      );
      if (
        foundWaiterKitchen &&
        type == "preparing" &&
        nextStatusIdFromClickEvent == 1
      ) {
        let foundOnReady = readyFoodDetail.find((x) => x.id == order.id);
        if (foundOnReady) {
          toast.error("Order Found On Ready", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          return;
        }
      }
      const updatedOrder = await axios
        .post(
          `${process.env.REACT_APP_SECRET}/api/QueueManagement/InsertIntoQueueManagementTableByRestaurantIdFromStatusCodeAndToStatusCode?fromStatusCode=${order.toStatus}&toStatusCode=${nextStatusIdFromClickEvent}&orderId=${order.id}`,
          kitchenIds
        )
        .then(() => {
          reloadData();
        });
    } catch (error) {
      console.log(error);
    }
  };
  const getNextStatus = (prop) => {
    switch (prop) {
      case "Preparing":
        setNextStatus("Ready");
        setPrevStatus("Pending");
        setNextStatusId(6);
        setPrevStatusId(1);
        break;
      case "Pending":
        setNextStatus("Preparing");
        setPrevStatus("Queue");
        setNextStatusId(5);
        setPrevStatusId(13);
        break;
      case "Queue":
        setNextStatus("Pending");
        setPrevStatus("None");
        setNextStatusId(1);
        setPrevStatusId(0);
        break;
      case "Ready":
        setNextStatus("None");
        setPrevStatus("Preparing");
        setNextStatusId(0);
        setPrevStatusId(5);
        break;
      default:
        setNextStatus("None");
        setPrevStatus("None");
        setNextStatusId(0);
        setPrevStatusId(0);
        break;
    }
  };
  useEffect(() => {
    getNextStatus(order.toStatusData);
  }, [order]);

  useEffect(() => {
    console.log(kitchenselected);

    let foundWaiterKitchen = kitchenselected?.find(
      (data) => String(data.title) === String("Waiter Kitchen")
    );
    if (foundWaiterKitchen) {
      setIsWaitersView(true);
    } else {
      setIsWaitersView(false);
    }
  }, [kitchenselected]);

  console.log(IsWaitersView);

  const getLastFourDigits = (id) => {
    const orderId = id.toString();
    return `${orderId.slice(-6)}`;
  };

  const loadCancelationReasons = async () => {
    await axios
      .get(`${process.env.REACT_APP_SECRET}/api/OrderCancelationReason`)
      .then((res) => {
        var list = [];
        res.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            title: dt.cancelationReason,
          };
          list.push(obj);
        });
        setCencalationReasons(list);
      });
  };

  const handleOrderCancel = (orderId) => {
    loadCancelationReasons();
    setOpenOrderCancelationModal(true);
  };

  const handleCancelOrder = async () => {
    var obj = {
      id: 0,
      orderId: order.id,
      statusId: "IS006",
      isRefunded: true,
      cancelationReasonId:
        selectCencalationReason.id != undefined
          ? selectCencalationReason.id
          : "CR007",
      cancelationReason:
        selectCencalationReason.title != undefined
          ? selectCencalationReason.title
          : "Not Provided",
      remarks: remarks,
      restaurantId: restaurantId,
      kitchenId: order.kitchenId,
    };
    await axios
      .post(`${process.env.REACT_APP_SECRET}/api/Order/CancelOrder`, obj)
      .then((res) => {
        toast.success("Order successfully canceled", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setOpenOrderCancelationModal(false);
        reloadData();
      });
  };

  const handleOrderStatusChangeAtServe = async () => {
    try {
      var kitchenIds = order?.kitchenViews.map((x) => x.kitchenId);

      let subOrderId = null

      if (order?.kitchenViews?.length) {
        for (const kitchenView of order.kitchenViews) {
          const deliverySubOrder = kitchenView.subOrders?.find(
            (subOrder) => subOrder.orderTypeName != "Delivery"
          );
          if (deliverySubOrder) {
            subOrderId = deliverySubOrder.id;
            break; // stop once found
          }
        }
      }
      console.log('order', order)
      const updatedOrder = await axios
        .post(
          `${process.env.REACT_APP_SECRET
          }/api/Order/InsertIntoQueueManagementTableByServe?fromStatusCode=${6}&toStatusCode=${15}&orderId=${order.id}&fromTable=${"qe_Ready"}&subOrderId=${subOrderId}&restaurantId=${restaurantId}`,
          kitchenIds
        )
        .then(() => {
          toast.success("Order Served", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          reloadData();
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOrderStatusChangeAtServedToReady = async () => {
    try {
      var kitchenIds = order?.kitchenViews.map((x) => x.kitchenId);

      var subOrderId = order?.kitchenViews[0]?.subOrders[0]?.id
      console.log('order', order)
      const updatedOrder = await axios
        .post(
          `${process.env.REACT_APP_SECRET
          }/api/Order/InsertIntoQueueManagementTableByServe?fromStatusCode=${15}&toStatusCode=${6}&orderId=${order.id}&fromTable=${"qe_Ready"}&subOrderId=${subOrderId}&restaurantId=${restaurantId}`,
          kitchenIds
        )
        .then(() => {
          toast.success("Order Status Reverted", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          reloadData();
          setopenConfirmaitonModal(false)
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOrderStatusChangeAtCollect = async () => {
    try {
      var kitchenIds = order?.kitchenViews.map((x) => x.kitchenId);

      let subOrderId = null

      if (order?.kitchenViews?.length) {
        for (const kitchenView of order.kitchenViews) {
          const deliverySubOrder = kitchenView.subOrders?.find(
            (subOrder) => subOrder.orderTypeName === "Delivery"
          );
          if (deliverySubOrder) {
            subOrderId = deliverySubOrder.id;
            break; // stop once found
          }
        }
      }

      console.log('order', order)
      const updatedOrder = await axios
        .post(
          `${process.env.REACT_APP_SECRET
          }/api/Order/InsertIntoQueueManagementTableByServe?fromStatusCode=${6}&toStatusCode=${17}&orderId=${order.id}&fromTable=${"qe_Ready"}&subOrderId=${subOrderId}&restaurantId=${restaurantId}`,
          kitchenIds
        )
        .then(() => {
          toast.success("Order Collected", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          reloadData();
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOrderStatusChangeAtCollected = async () => {
    try {
      var kitchenIds = order?.kitchenViews.map((x) => x.kitchenId);

      let subOrderId = null

      if (order?.kitchenViews?.length) {
        for (const kitchenView of order.kitchenViews) {
          const deliverySubOrder = kitchenView.subOrders?.find(
            (subOrder) => subOrder.orderTypeName === "Delivery"
          );
          if (deliverySubOrder) {
            subOrderId = deliverySubOrder.id;
            break; // stop once found
          }
        }
      }

      console.log('order', order)
      const updatedOrder = await axios
        .post(
          `${process.env.REACT_APP_SECRET
          }/api/Order/InsertIntoQueueManagementTableByServe?fromStatusCode=${17}&toStatusCode=${6}&orderId=${order.id}&fromTable=${"qe_Ready"}&subOrderId=${subOrderId}&restaurantId=${restaurantId}`,
          kitchenIds
        )
        .then(() => {
          toast.success("Order Status Reverted", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          reloadData();
        });
    } catch (error) {
      console.log(error);
    }
  };

  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);

  return (
    <div>
      <ToastContainer />
      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"This action will set order status to ready?"}
        open={openConfirmaitonModal}
        onyes={handleOrderStatusChangeAtServedToReady}
        close={() => {
          setopenConfirmaitonModal(false);
        }}
      />
      <div
        className="text-start mt-2 d-flex p-2"
        style={{
          justifyContent: "space-between",
        }}
      >
        <div
          className="text-start  d-flex w-100 ms-1 me-1"
          style={{
            justifyContent: "space-between",
            // flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography className="orderQueueCardTitle">
            #Order {getLastFourDigits(order.id)}
          </Typography>
          <Tooltip
            title={
              order?.creationDate
                ? moment(order.creationDate).format("DD/MM/YYYY")
                : ""
            }
          >
            <Typography sx={{ color: "#56595B", fontSize: "12px" }}>
              {moment(order.creationDate).format("DD/MM/YYYY")}{" "}
              {formatTime(order?.creationDate)}
            </Typography>
          </Tooltip>
        </div>
        <div
          onClick={() => {
            toast("Upcoming Feature");
          }}
        >
          <img src={chatImg} style={{ width: "1rem" }} />
        </div>
      </div>
      <hr className="pt-0 mt-1 w-100" />

      <div
        className="d-flex"
        style={{ flexDirection: "column", gap: "10px", margin: "10px" }}
      >
        {order?.kitchenViews?.length > 0 &&
          order?.kitchenViews?.map((food, index) => (
            <>
              <Card sx={{ paddingBottom: "0px", marginBottom: "0px" }}>
                <CardContent
                  sx={{
                    paddingBottom: "10px !important",
                    padding: "0px !important",
                  }}
                >
                  {/* Kitchen name & Status */}
                  <div
                    className="d-flex"
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      padding: "10px",
                    }}
                  >
                    <Typography className="orderQueueCardTableNo">
                      {food.kitchenName}
                    </Typography>
                    <div
                      className="d-flex justify-content-between  pt-1 align-items-center"
                      style={{
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <Chip
                        label={food.toStatusData}
                        className={`${food.toStatusData == "Queue"
                            ? "queue-status"
                            : food.toStatusData == "Pending"
                              ? "pending-status"
                              : food.toStatusData == "Preparing"
                                ? "preparing-status"
                                : "ready-status"
                          }`}
                      />
                      {/* <Typography sx={{ color: "#56595B" }}>
                        {formatTime(order?.creationDate)}
                      </Typography> */}
                    </div>
                  </div>

                  {food.subOrders.map((subOrder, i) => {
                    const itemsToShow = showAll
                      ? subOrder.orderItemDetailViews
                      : subOrder.orderItemDetailViews.slice(0, 2);

                    return (
                      <div key={i}>
                        <div className="OrderItemsDiv">
                          <hr className="pt-0 mt-1 w-100" />

                          {/* Delivery / table selection section */}
                          <div
                            className="d-flex mb-2"
                            style={{
                              flexDirection: "row",
                              justifyContent: "end",
                              gap: "10px",
                              alignItems: "center",
                            }}
                          >
                            {/* {subOrder.orderTypeDetails != "Delivery" &&
                              subOrder.orderTypeDetails != "dineIn" &&
                              food.toStatusData != "Queue" &&
                              food.toStatusData != "Pending" &&
                              food.toStatusData != "Preparing" && (
                                <div
                                  style={{ cursor: "pointer" }}
                                  className="serveDiv"
                                  onClick={() => {
                                    handleOrderStatusChangeAtServe();
                                  }}
                                >
                                  <Chip label={"Serve"} className={`serve`} />
                                </div>
                              )} */}

                            {subOrder.orderTypeDetails !== "Delivery" &&
                              subOrder.orderTypeDetails !== "dineIn" &&
                              food.toStatusData !== "Queue" &&
                              food.toStatusData !== "Pending" &&
                              food.toStatusData !== "Preparing" && (
                                <div
                                  style={{ cursor: "pointer" }}
                                  className="serveDiv"
                                  onClick={() => {
                                    if (subOrder.toStatusDataSO === '15') {
                                      setopenConfirmaitonModal(true);
                                    } else {
                                      handleOrderStatusChangeAtServe();
                                    }
                                  }}
                                >
                                  <Chip
                                    label={subOrder.toStatusDataSO === '15' ? "Served" : "Serve"}
                                    className={subOrder.toStatusDataSO === '15' ? "served" : "serve"}
                                  />
                                </div>
                              )}

                            <Chip
                              label={
                                subOrder.orderTypeName === "Delivery" ? (
                                  <span
                                    className="d-flex"
                                    style={{ gap: "3px", cursor: "pointer" }}
                                    onClick={() => {
                                      if (subOrder.toStatusDataSO === "17") {
                                        handleOrderStatusChangeAtCollected();
                                      } else {
                                        handleOrderStatusChangeAtCollect();
                                      }
                                    }}
                                  >
                                    {subOrder.toStatusDataSO === "17" ? "Collected" : "Collect"}
                                  </span>
                                ) : (
                                  <span
                                    className={"d-flex"}
                                    style={{ gap: "3px", cursor: "pointer" }}
                                    onClick={() => {
                                      setOpenTableEdit(true);
                                      setSelectedSubOrder(subOrder);
                                    }}
                                  >
                                    {subOrder.orderTypeDetails}{" "}
                                    {subOrder.orderTypeName !== "Delivery" && (
                                      <img
                                        src={editIcon}
                                        alt="Edit Icon"
                                        style={{
                                          width: "1.2rem",
                                          padding: "3px",
                                        }}
                                      />
                                    )}{" "}
                                  </span>
                                )
                              }
                              className={clsx({
                                delivery:
                                  subOrder.orderTypeName === "Delivery" ||
                                  subOrder.orderTypeName === "delivery",
                                dineIn:
                                  subOrder.orderTypeName !== "Delivery" &&
                                  subOrder.orderTypeName !== "delivery",
                              })}
                            />
                          </div>

                          {/* Food Items */}
                          {itemsToShow.map((item, i) => {
                            return (
                              <React.Fragment key={i}>
                                <OrderQueueCard
                                  ItemDetails={item}
                                  from={order.toStatusData}
                                  handleOrderStatusChange={
                                    handleOrderStatusChange
                                  }
                                  index={i}
                                  reload={reloadData}
                                  nextStatusId={nextStatusId}
                                  restaurantId={restaurantId}
                                  isWaitersView={IsWaitersView}
                                />
                                <hr className="pt-0 mt-1 mb-1 w-100" />
                              </React.Fragment>
                            );
                          })}

                          {/* Show arrow button if there are more than 3 items */}
                          {subOrder.orderItemDetailViews.length > 2 && (
                            <div
                              className="d-flex justify-content-center"
                              style={{ cursor: "pointer" }}
                              onClick={toggleShowAll} // Toggle view on click
                            >
                              {showAll ? (
                                <span>▲ Show Less</span>
                              ) : (
                                <span>▼ Show More</span>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </CardContent>
              </Card>
            </>
          ))}
      </div>

      {IsWaitersView == false && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "space-between",
            padding: ".9rem",
          }}
        >
          {/* Container for the first two buttons (See Details and Move to / Back to) */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Button
              variant="contained"
              style={{
                backgroundColor: "#4E4E4E",
                color: "#FFFFFF",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                textTransform: "none",
                borderRadius: "20px",
                flex: "1",
                fontSize: "12px",
              }}
              onClick={handleOpen}
            >
              See Details
            </Button>

            {nextStatus !== "None" ? (
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#d0efdb",
                  color: "#13b04c",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  textTransform: "none",
                  borderRadius: "20px",
                  flex: "1",
                  textWrap: "nowrap",
                  fontSize: "12px",
                }}
                onClick={() => {
                  handleOrderStatusChange(nextStatusId);
                }}
              >
                Move to {nextStatus}
              </Button>
            ) : (
              prevStatus !== "None" && (
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#FAEBD7",
                    color: "#F4A460",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    textTransform: "none",
                    borderRadius: "20px",
                    flex: "1",
                    textWrap: "nowrap",
                    fontSize: "12px",
                  }}
                  onClick={() => {
                    handleOrderStatusChange(prevStatusId);
                  }}
                >
                  Back to {prevStatus}
                </Button>
              )
            )}
          </div>

          {/* Third button only shows if both "Move to" and "Back to" buttons are present */}
          {nextStatus !== "None" && prevStatus !== "None" && (
            <Button
              variant="contained"
              style={{
                backgroundColor: "#FAEBD7",
                color: "#F4A460",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                textTransform: "none",
                borderRadius: "20px",
                width: "100%",
                textWrap: "nowrap",
                fontSize: "12px",
              }}
              onClick={() => {
                handleOrderStatusChange(prevStatusId);
              }}
            >
              Back to {prevStatus}
            </Button>
          )}
          <Button
            variant="contained"
            style={{
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              textTransform: "none",
              borderRadius: "20px",
              width: "100%",
              textWrap: "nowrap",
              fontSize: "12px",
              color: "white",
              backgroundColor: "#ef5350",
            }}
            onClick={() => {
              handleOrderCancel(order.id);
            }}
          >
            Cancel Orders
          </Button>
        </div>
      )}

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box
            sx={{
              ...style,
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <h5 style={{ color: "#2a7fd4" }}>GoTaste:- Order Details</h5>
              <Button onClick={handleClose}>
                <img src={closeIcon} style={{ width: "1rem" }} />
              </Button>
            </div>
            <div
              className="d-flex"
              style={{ justifyContent: "center", flexWrap: "wrap" }}
            >
              <OrderItemModal
                orderDetails={order}
                reload={reloadData}
                from={"Modal"}
              ></OrderItemModal>
            </div>
            <Grid
              md={12}
              sx={{
                display: "flex",
                justifyContent: "end",
                gap: "10px",
                marginTop: "1rem",
              }}
            >
              <Button variant="outlined" color="error" onClick={handleClose}>
                Close
              </Button>
            </Grid>
          </Box>
        </Fade>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openOrderCancelationModal}
        onClose={handleCloseOrderCancelationModal}
      >
        <Fade in={openOrderCancelationModal}>
          <Box
            sx={{
              ...styleForOrderCancelationModal,
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <h5 style={{ color: "#2a7fd4" }}>
                GoTaste:- Cancel Order No: #{getLastFourDigits(order.id)}
              </h5>
              <Button onClick={handleCloseOrderCancelationModal}>
                <img src={closeIcon} style={{ width: "1rem" }} />
              </Button>
            </div>
            <br />
            <Grid container>
              <Grid xs={12} md={12} sx={{ marginTop: ".8rem" }}>
                <AutoCompleteMultiSelect
                  id={33}
                  placeholder={"Select Cancelation Reason (Optional)"}
                  datas={cencalationReasons}
                  value={(res) => {
                    setSelectCencalationReason(res);
                  }}
                />
              </Grid>
              <Grid xs={12} md={12} sx={{ marginTop: ".8rem" }}>
                <TextAreaComponents
                  id={1}
                  value={(res) => {
                    setRemarks(res);
                    console.log("remarks", remarks);
                  }}
                  label={"Remarks (Optional)"}
                />
              </Grid>
              <Grid
                md={12}
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  gap: "10px",
                  marginTop: "1rem",
                }}
              >
                <Button
                  variant="outlined"
                  color="success"
                  onClick={() => {
                    handleCancelOrder();
                  }}
                >
                  Cancel Item
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={handleCloseOrderCancelationModal}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
      {openTableEdit && (
        <OrderTableDialog
          open={openTableEdit}
          onclose={() => {
            setOpenTableEdit(false);
            reloadData();
          }}
          subOrder={selectedSubOrder}
        />
      )}
    </div>
  );
};

export default OrderDetailsCardContent;
